export const GET_TRANSACTION_REQUEST="GET_TRANSACTION_REQUEST";
export const GET_TRANSACTION_SUCCESS="GET_TRANSACTION_SUCCESS";
export const GET_TRANSACTION_FAILURE="GET_TRANSACTION_FAILURE";
export const UPDATE_TRANSACTION_REQUEST="UPDATE_TRANSACTION_REQUEST";
export const UPDATE_TRANSACTION_SUCCESS="UPDATE_TRANSACTION_SUCCESS";
export const UPDATE_TRANSACTION_FAILURE="UPDATE_TRANSACTION_FAILURE";
export const DELETE_TRANSACTION_REQUEST="DELETE_TRANSACTION_REQUEST";
export const DELETE_TRANSACTION_SUCCESS="DELETE_TRANSACTION_SUCCESS";
export const DELETE_TRANSACTION_FAILURE="DELETE_TRANSACTION_FAILURE";
export const CREATE_TRANSACTION_REQUEST="CREATE_TRANSACTION_REQUEST";
export const CREATE_TRANSACTION_SUCCESS="CREATE_TRANSACTION_SUCCESS";
export const CREATE_TRANSACTION_FAILURE="CREATE_TRANSACTION_FAILURE";
export const GET_ALL_TRANSACTION_REQUEST="GET_ALL_TRANSACTION_REQUEST";
export const GET_ALL_TRANSACTION_SUCCESS="GET_ALL_TRANSACTION_SUCCESS";
export const GET_ALL_TRANSACTION_FAILURE="GET_ALL_TRANSACTION_FAILURE";